declare namespace $ {

	type $mol_check_icon__hint_giper_balls_chess_game_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_giper_balls_chess_game_2 = $mol_type_enforce<
		ReturnType< $giper_balls_chess_game['Autobot_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_giper_balls_chess_game_3 = $mol_type_enforce<
		ReturnType< $giper_balls_chess_game['autobot'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	export class $giper_balls_chess_game extends $giper_balls_game {
		Autobot_icon( ): $mol_icon_brain
		autobot( next?: boolean ): boolean
		Autobot( ): $mol_check_icon
		thinking( ): any
		autoboting( ): any
		title( ): string
		State( next?: $giper_balls_chess_state ): $giper_balls_chess_state
		last_coord( next?: number ): number
		mood_smiles( ): readonly(any)[]
		tools( ): readonly(any)[]
		auto( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=game.view.tree.d.ts.map